import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/layouts/empty.vue").then(m => m.default || m)),
  full: defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/layouts/full.vue").then(m => m.default || m)),
  "planned-deliveries": defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/layers/planned-deliveries/layouts/planned-deliveries.vue").then(m => m.default || m))
}